export var LEFT_ITEMS = [{
  url: 'https://gaoding.com',
  img: 'https://st-gdx.dancf.com/gaodingx/213/configs/system/20200907-115221-dd97.svg',
  title: '稿定官网',
  desc: '海量海报模板，让设计更简单'
}, {
  url: 'https://koutu.gaoding.com/',
  img: 'https://st-gdx.dancf.com/gaodingx/213/configs/system/20200907-115420-5603.svg',
  title: '稿定抠图',
  desc: '在线删除图片背景'
}];
export var RIGHT_ITEMS = [{
  url: 'https://sucai.gaoding.com/',
  img: 'https://st-gdx.dancf.com/gaodingx/4323/configs/system/20211208-162051-e03b.png',
  title: '稿定素材'
}, {
  url: 'https://www.gaoding.com/image',
  img: 'https://st-gdx.dancf.com/gaodingx/4323/configs/system/20211208-162110-1e5b.png',
  title: '图片编辑器'
}, {
  url: 'https://ps.gaoding.com/#/',
  img: 'https://st-gdx.dancf.com/gaodingx/4323/configs/system/20211208-162123-8f7a.png',
  title: '在线PS'
}, {
  url: 'https://www.gaoding.com/pintu',
  img: 'https://st-gdx.dancf.com/gaodingx/4323/configs/system/20211208-162141-8fa2.png',
  title: '在线拼图'
}, {
  url: 'https://www.gaoding.com/poster-generator',
  img: 'https://st-gdx.dancf.com/gaodingx/4323/configs/system/20211208-162154-6312.png',
  title: '一键生成海报'
}, {
  url: 'https://www.gaoding.com/ppt/plugin',
  img: 'https://st-gdx.dancf.com/gaodingx/4323/configs/system/20211208-162207-c665.png',
  title: 'PPT插件'
}, {
  url: 'https://www.gaoding.com/clipper',
  img: 'https://st-gdx.dancf.com/gaodingx/4323/configs/system/20211208-162225-fb98.png',
  title: '在线剪视频'
}, {
  url: 'https://www.gaoding.com/odyssey/design',
  img: 'https://st-gdx.dancf.com/gaodingx/4323/configs/system/20211208-162240-3be8.png',
  title: '手机网页制作'
}];